import type { Template } from "@/types";

export const LA_07_H6_V1: Template[] = [
{
    id: "la-07-h6v1-01",
    name: "LA 01 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 62, y: 68, width: 264, height: 167, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 241, width: 264, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 334, y: 68, width: 243, height: 340, rotation: 0, imageRotation: 0 },
            { id: "4", x: 694, y: 68, width: 259, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 694, y: 241, width: 259, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 961, y: 68, width: 258, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 961, y: 241, width: 258, height: 167, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-02",
    name: "LA 02 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 97, y: 39, width: 443, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 97, y: 310, width: 218, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 310, width: 218, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 715, y: 39, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 715, y: 175, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 715, y: 310, width: 188, height: 127, rotation: 0, imageRotation: 0 },
            { id: "7", x: 911, y: 39, width: 286, height: 399, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-03",
    name: "LA 03 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 90, y: 51, width: 459, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 90, y: 323, width: 148, height: 101, rotation: 0, imageRotation: 0 },
            { id: "3", x: 245, y: 323, width: 148, height: 101, rotation: 0, imageRotation: 0 },
            { id: "4", x: 400, y: 323, width: 148, height: 101, rotation: 0, imageRotation: 0 },
            { id: "5", x: 768, y: 51, width: 354, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 768, y: 280, width: 242, height: 145, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 280, width: 105, height: 145, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-04",
    name: "LA 04 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 111, y: 46, width: 204, height: 124, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 46, width: 204, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 111, y: 177, width: 204, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 322, y: 177, width: 204, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 111, y: 308, width: 204, height: 124, rotation: 0, imageRotation: 0 },
            { id: "6", x: 322, y: 308, width: 204, height: 124, rotation: 0, imageRotation: 0 },
            { id: "7", x: 808, y: 46, width: 296, height: 386, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-05",
    name: "LA 05 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 168, y: 35, width: 302, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 718, y: 35, width: 310, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 874, y: 241, width: 311, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 241, width: 149, height: 96, rotation: 0, imageRotation: 0 },
            { id: "5", x: 718, y: 344, width: 149, height: 95, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1036, y: 35, width: 149, height: 96, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1036, y: 138, width: 149, height: 96, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-06",
    name: "LA 06 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 74, y: 47, width: 487, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 335, width: 158, height: 96, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 335, width: 157, height: 96, rotation: 0, imageRotation: 0 },
            { id: "4", x: 405, y: 335, width: 157, height: 96, rotation: 0, imageRotation: 0 },
            { id: "5", x: 699, y: 47, width: 243, height: 385, rotation: 0, imageRotation: 0 },
            { id: "6", x: 950, y: 47, width: 262, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 950, y: 243, width: 262, height: 188, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-07",
    name: "LA 07 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 70, y: 35, width: 275, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 352, y: 35, width: 204, height: 131, rotation: 0, imageRotation: 0 },
            { id: "3", x: 352, y: 173, width: 204, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 352, y: 310, width: 204, height: 130, rotation: 0, imageRotation: 0 },
            { id: "5", x: 724, y: 35, width: 462, height: 269, rotation: 0, imageRotation: 0 },
            { id: "6", x: 724, y: 311, width: 227, height: 130, rotation: 0, imageRotation: 0 },
            { id: "7", x: 958, y: 311, width: 227, height: 130, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-08",
    name: "LA 08 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 70, y: 35, width: 204, height: 131, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 173, width: 204, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 70, y: 310, width: 204, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 282, y: 35, width: 275, height: 405, rotation: 0, imageRotation: 0 },
            { id: "5", x: 836, y: 36, width: 239, height: 131, rotation: 0, imageRotation: 0 },
            { id: "6", x: 836, y: 174, width: 239, height: 130, rotation: 0, imageRotation: 0 },
            { id: "7", x: 836, y: 311, width: 239, height: 130, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-09",
    name: "LA 09 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 55, y: 34, width: 286, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 241, width: 286, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 349, y: 34, width: 286, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 349, y: 241, width: 286, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 34, width: 285, height: 405, rotation: 0, imageRotation: 0 },
            { id: "6", x: 934, y: 34, width: 286, height: 200, rotation: 0, imageRotation: 0 },
            { id: "7", x: 934, y: 241, width: 286, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h6v1-10",
    name: "LA 10 - H6V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 55, y: 34, width: 286, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 241, width: 286, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 349, y: 34, width: 286, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 349, y: 241, width: 286, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 34, width: 286, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 642, y: 241, width: 286, height: 199, rotation: 0, imageRotation: 0 },
            { id: "7", x: 935, y: 34, width: 285, height: 405, rotation: 0, imageRotation: 0 }
    ],
}
];